<template>
    <v-card class="pa-3 grey lighten-3">
        <v-data-table :headers="tableHeader" :items="items" :search="search" class="elevation-1" hide-default-footer
                      @page-count="pageCount = $event" :page.sync="page" :items-per-page="itemsPerPage">
            <template v-slot:item.changesRaw="{ item }">
                <div :class="[{'changeCol': $vuetify.breakpoint.smAndUp}, 'my-3 px-4 grey lighten-5']">
                    <v-row v-for="(change, i) in item.changesRaw" :key="i">
                        <v-col class="pl-0 pr-1 py-1 font-weight-medium" cols="4">{{change.field}}:</v-col>
                        <v-col class="px-0 py-1 text-truncate" cols="3" v-if="change.valueOld">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{change.valueOld}}</span>
                                </template>
                                <span>{{change.valueOld}}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col class="px-0 py-1 text-center" cols="1" v-if="change.valueOld">-></v-col>
                        <v-col class="px-0 py-1 primary--text" :cols="change.valueOld?4:7">{{change.valueNew}}</v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:no-data>
                Dieser Spieler wurde nach der Passvergabe noch nicht geändert!
            </template>
        </v-data-table>
        <v-pagination v-if="pageCount>1" v-model="page" :length="pageCount"></v-pagination>
    </v-card>
</template>

<script>
    import SPIELER_ACTION_LISTS from "../../../services/data/spielerAction/spielerActionLists";
    export default {
        name: "spieler-log",
        props: ['spieler'],
        data: () => ({
            log: [],
            tableHeader: [],
            items: [],
            search: '',
        // pagination
            page: 1,
            pageCount: 0,
            itemsPerPage: 15,
        }),
        created(){
            this.getLog();
        },
        methods: {
            async getLog() {
                this.log = [];
                this.items = [];
                let params = {
                    collection: 'spieler_actions',
                    queryField: 'search_spieler',
                    queryOperator: '==',
                    queryValue: this.spieler.id,
                };
                let reply = await this.$store.dispatch('getTempSnapshotList', params);
                if ( reply.successful ) {
                    this.log = reply.content;
                    this.createTable();
                } else {
                    console.error ("KEINE DATEN");
                }
            },
            createTable(){
                this.tableHeader = SPIELER_ACTION_LISTS.getTableHeaders('spielerInfoLog');
                this.createTableItems();
            },
            createTableItems(){
                this.log.forEach( (logItem) => {
                    let item  = SPIELER_ACTION_LISTS.getTableItem('spielerInfoLog', logItem);
                    this.items.push(item);
                });
                this.items.sort((a, b) => a.createdAtSortable < b.createdAtSortable ? 1 : -1);
            }
        },
        watch: {
            spieler: {
                handler(){
                    console.log ("WATCH spieler");
                    this.getLog();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>